const NAVBAR_LOGO_HEIGHT = 20;
const NAVBAR_LOGO_WIDTH = 112;
const NAVBAR_NAV_HEIGHT = 59;
const NAVBAR_MAX_WIDTH = 1228;
const NAVBAR_SUB_NAV_HEIGHT = 52;
const NAVBAR_BANNER_HEIGHT = 32;
const NAVBAR_SECONDARY_LOGO_WIDTH = 150;
const SUBNAV_CONTAINER_Z_INDEX = 1;
const GLOBAL_HEADER_CONTAINER_Z_INDEX = 10;
const GLOBAL_HEADER_HEIGHT = 112;
const GLOBAL_HEADER_BREAKPOINT_DESKTOP = 1050;
const BANNER_HEIGHT_45 = 45;
const BANNER_HEIGHT_0 = 0;
const UK_BANNER_HEIGHT = 120;
export { BANNER_HEIGHT_0, BANNER_HEIGHT_45, GLOBAL_HEADER_BREAKPOINT_DESKTOP, GLOBAL_HEADER_CONTAINER_Z_INDEX, GLOBAL_HEADER_HEIGHT, NAVBAR_BANNER_HEIGHT, NAVBAR_LOGO_HEIGHT, NAVBAR_LOGO_WIDTH, NAVBAR_MAX_WIDTH, NAVBAR_NAV_HEIGHT, NAVBAR_SECONDARY_LOGO_WIDTH, NAVBAR_SUB_NAV_HEIGHT, SUBNAV_CONTAINER_Z_INDEX, UK_BANNER_HEIGHT };
//# sourceMappingURL=constants.js.map
